import { TREATMENT_INSTANCE_COPY_GET_SUCCESS } from '../../constants/types';
import { queryStringBuilder } from '../../../utils/helpers';
import axios from '../../../utils/axios';

const successRequest = response => ({
  type: TREATMENT_INSTANCE_COPY_GET_SUCCESS,
  response,
});

export const getTreatmentInstancesCopies = (assignmentId, teamId, jwtToken) => async dispatch => {
  const token = `Bearer ${jwtToken}`;
  const parameters = {
    assignmentId,
    teamId,
  };
  const response = await axios({
    url: `v1/query/GetTreatmentInstanceCopies${queryStringBuilder(parameters)}`,
    headers: {
      Authorization: token,
    },
  });
  dispatch(successRequest(response));
};
